import React, { useCallback, useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { getFooterMenu } from '../../../constants/Qmenu';
import FooterMenuList from './components/FooterMenuList';
import * as S from './style';
import { Collapse } from 'antd';
import { Link } from 'react-router-dom';

import Currency from './assets/Currency.svg?react';
import Global from './assets/Global.svg?react';

import Dark_Currency from './assets/Dark-Currency.svg?react';
import Dark_Global from './assets/Dark-Global.svg?react';

import { ThemeContext } from '@/theme/ThemeProvider';
import CurrencyModal from '@app/organisms/Footer/CurrencyChange/CurrencyModal';
import LanguageModal from '@app/organisms/Header/BtnLanguageChange/LanguageModal';
import { CModal } from '@components/Common';
import { useTranslation } from 'react-i18next';
import { media } from '../../../../styles/Qtheme';
import { MobileCalVW, TabletCalVW, useIsTablet } from '../../../../utils/CalVW';
import * as IconList from './IconList';

function Footer({ themeToggler }: any) {
  const [activeMenu, setActiveMenu] = useState<string | null>(null);
  const [isDefault, setIsDefault] = useState(true);
  const { isDarkMode, toggleTheme } = useContext(ThemeContext);
  const theme = isDarkMode ? 'dark' : 'light';
  const { t, i18n } = useTranslation();
  const [footerMenuItems, setFooterMenuItems] = useState(getFooterMenu());

  const [showModal, setShowModal] = useState(false);
  const closeModal = () => setShowModal && setShowModal(false);
  const openModal = () => {
    setShowModal(true);
  };

  const [showCurrencyModal, setShowCurrencyModal] = useState(false);
  const closeCurrencyModal = () =>
    setShowCurrencyModal && setShowCurrencyModal(false);
  const openCurrencyModal = () => {
    setShowCurrencyModal(true);
  };

  const IsTablet = useIsTablet();

  const handleToggleMenu = useCallback(
    (menu: string) => {
      if (activeMenu === menu) {
        setActiveMenu(null);
      } else {
        setActiveMenu(menu);
      }
    },
    [activeMenu]
  );

  const Icons = [
    <IconList.FaceBookIcon key="facebook" />,
    <IconList.InstagramIcon key="instagram" />,
    <IconList.BotIcon key="bot" />,
    <IconList.MusicIcon key="music" />,
    <IconList.XIcon key="x" />,
    <IconList.CallIcon key="call" />,
    <IconList.YouTubeIcon key="youtube" />,
    <IconList.EarIcon key="ear" />,
    <IconList.DiscordIcon key="discord" />,
    <IconList.GhostIcon key="ghost" />,
  ];

  useEffect(() => {
    if (activeMenu) {
      setIsDefault(false);
    } else {
      setIsDefault(true);
    }
  }, [activeMenu]);

  useEffect(() => {
    // i18n 언어가 변경될 때마다 메뉴를 업데이트
    setFooterMenuItems(getFooterMenu());
  }, [i18n.language]);

  return (
    <S.Container id="footer-container">
      <S.FooterTopContainer>
        {!IsTablet && (
          <LeftSide>
            <CommuWrapper>
              <CommuLabel>{t('community')}</CommuLabel>
              <CommuContents>{Icons}</CommuContents>
            </CommuWrapper>
            <UtilWrapper>
              <UtilRow onClick={openModal}>
                <UtilIcon as={theme === 'light' ? Dark_Global : Global} />
                <UtilText>{t('language')}</UtilText>
              </UtilRow>

              <CModal
                visible={showModal}
                onClose={closeModal}
                bgColor={'transparent'}
                isResponsive
              >
                <LanguageModal closeModal={closeModal} />
              </CModal>

              <UtilRow onClick={openCurrencyModal}>
                <UtilIcon as={theme === 'light' ? Dark_Currency : Currency} />
                <UtilText>{t('currency')}</UtilText>
              </UtilRow>

              <CModal
                visible={showCurrencyModal}
                onClose={closeCurrencyModal}
                bgColor={'transparent'}
                isResponsive
              >
                <CurrencyModal closeModal={closeCurrencyModal} />
              </CModal>

              <UtilRow onClick={() => themeToggler()}>
                <UtilText>{t('theme')}</UtilText>
                <IconList.ColorThemeIcon />
              </UtilRow>
            </UtilWrapper>
          </LeftSide>
        )}

        {!IsTablet ? (
          <S.FooterMenuBox>
            {footerMenuItems.map((menu, index) => (
              <FooterMenuList
                key={`footer-menu-${index}`}
                isDefault={isDefault}
                activeMenu={activeMenu}
                handleToggleMenu={handleToggleMenu}
                menu={menu}
              />
            ))}
          </S.FooterMenuBox>
        ) : (
          <StyledCollapse ghost>
            {footerMenuItems.map((menu, index) => (
              <Collapse.Panel header={menu.title} key={index}>
                <SubMenuList>
                  {menu.subMenu.map((subMenu: any, subIndex: number) => (
                    <li key={`submenu-${subIndex}`}>
                      <Link to={subMenu.link}>{subMenu.title}</Link>
                    </li>
                  ))}
                </SubMenuList>
              </Collapse.Panel>
            ))}
          </StyledCollapse>
        )}
        {/*<S.IconContainer>*/}
        {/*	<button>*/}
        {/*		<img src="/images/facebook-light.png" alt="" />*/}
        {/*	</button>*/}
        {/*	<button>*/}
        {/*		<img src="/images/insta-light.png" alt="" />*/}
        {/*	</button>*/}
        {/*	<button>*/}
        {/*		<img src="/images/ficon-light.png" alt="" />*/}
        {/*	</button>*/}
        {/*</S.IconContainer>*/}
      </S.FooterTopContainer>

      {IsTablet && (
        <CommuWrap>
          <CommuTitle>{t('community')}</CommuTitle>
          <MobileCommuContents>{Icons}</MobileCommuContents>
        </CommuWrap>
      )}

      <S.FooterBottomContainer>
        <p>
          <span>FossX</span> {t('copyright')} © 2013-2025.
        </p>
      </S.FooterBottomContainer>
    </S.Container>
  );
}

export default React.memo(Footer);

const LeftSide = styled.div`
  margin-right: 103px;
`;

const CommuWrapper = styled.div`
  margin-bottom: 52px;
`;

const UtilWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 22.5px;
`;

const UtilRow = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;
  cursor: pointer;
`;

const UtilText = styled.div`
  font-size: 14px;
  font-weight: 500;
  line-height: 16.71px;
  font-family: 'Pretendard', sans-serif;
  color: ${({ theme }) => theme.text};
`;

const UtilIcon = styled.svg`
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

const CommuLabel = styled.div`
  font-size: 16px;
  line-height: 19.09px;
  font-family: 'Pretendard', sans-serif;
  font-weight: 600;
  color: ${({ theme }) => theme.text};
  margin-bottom: 22px;
`;

const CommuContents = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr); /* 4열 */
  grid-template-rows: repeat(3, auto); /* 3행 */
  gap: 24px 30px; /* 세로 간격 24px, 가로 간격 30px */
`;

const CommuWrap = styled.div`
  width: 1200px;
  max-width: 1750px;
  padding: 55px 20px 30px;
  margin: 0 auto;

  @media ${media.desktop} {
    padding: 10px ${TabletCalVW(20)};
  }

  @media ${media.mobile} {
    padding: 25px ${MobileCalVW(16)} 0 ${MobileCalVW(16)};
  }
`;

const CommuTitle = styled.div`
  font-size: 16px;
  font-weight: 600;
  line-height: 19.09px;
  font-family: 'Pretendard', sans-serif;
  color: ${({ theme }) => theme.text};
`;

const MobileCommuContents = styled.div`
  display: grid;
  grid-template-columns: repeat(7, 1fr); /* 4열 */
  grid-template-rows: repeat(2, auto); /* 3행 */
  gap: 20px 14px; /* 세로 간격 24px, 가로 간격 30px */

  @media ${media.desktop} {
    padding: 28px 0;
    width: 400px;
  }

  @media ${media.mobile} {
    width: ${MobileCalVW(250)};
  }
`;

const StyledCollapse = styled(Collapse)`
  width: 100%;
  background: transparent;
  border: none;

  .ant-collapse-item {
    border-bottom: 1px solid ${({ theme }) => theme.p2pBorder};
  }

  .ant-collapse-item:last-child {
    border-bottom: none;
  }

  .ant-collapse-header {
    padding: 16px 0 !important;
    font-size: 16px;
    font-weight: 600;
    line-height: 19.09px;
    color: ${({ theme }) => theme.text} !important;
    font-family: 'Pretendard', sans-serif;
  }

  .ant-collapse-header-text {
    color: ${({ theme }) => theme.text} !important;
  }

  .ant-collapse-content {
    background: transparent;
    border: none;
  }

  .ant-collapse-content-box {
    padding: 0 0 16px 0 !important;
  }

  .ant-collapse-expand-icon {
    color: ${({ theme }) => theme.text} !important;
  }
`;

const SubMenuList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding-left: 24px;

  li {
    list-style: none;

    a {
      font-size: 14px;
      font-weight: 400;
      line-height: 16.71px;
      color: ${({ theme }) => theme.footerText};
      font-family: 'Pretendard', sans-serif;
      display: block;
      transition: color 0.3s;

      &:hover {
        color: ${({ theme }) => theme.primary};
      }
    }
  }
`;
